export default __webpack_public_path__ + "static/media/824.c1ceecb6.png";